export default __webpack_public_path__ + "images/Mixed_Display.webp?67d7fbc0efe2c6d766247e54f9dc5217";